import { useFlags } from 'launchdarkly-react-client-sdk';
import { PermissionKey } from '../../../services/PermissionAndRolesKeys';
import { PermissionService } from '../../../services/PermissionService';
import { MaggieFeatureFlags } from '../../../util/feature-flags';

export interface ManageAccessGates {
  companyAccess: boolean;
  gridColumnVisibility: boolean;
  fundAdminAccess: boolean;
  auditorSettings: boolean;
  /** The cards page; without it, the section opens straight on Company Access. */
  landing: boolean;
  /** The Manage Access nav item and route block. */
  section: boolean;
}

/** Single gating site for Manage Access, shared by the routes, the nav item and the pages. */
export function useManageAccessGates(): ManageAccessGates {
  const { showAdminManageAccess, showAdminManageAccessColumnGridDisplay, showFundAdminAccessConfig } =
    useFlags<MaggieFeatureFlags>();
  const canViewClientSettings = PermissionService.get().hasPermission(PermissionKey.canViewClientSettings);

  const companyAccess = Boolean(showAdminManageAccess);
  const gridColumnVisibility = companyAccess && Boolean(showAdminManageAccessColumnGridDisplay);
  // Same gate as the fund admin access endpoints (fd.customer-success.client-settings).
  const fundAdminAccess = companyAccess && Boolean(showFundAdminAccessConfig) && canViewClientSettings;
  // Permission only, with no flag: every client-settings user reaches Auditor Settings.
  const auditorSettings = canViewClientSettings;

  return {
    companyAccess,
    gridColumnVisibility,
    fundAdminAccess,
    auditorSettings,
    landing: gridColumnVisibility || fundAdminAccess || auditorSettings,
    section: companyAccess || auditorSettings,
  };
}
